import React, { useState } from 'react';
import './Services.css';

const modalContent = {
  control: {
    title: "Control & Instrumentation",
    detail: "Profibercom excels in the design, supply, and integration of industrial control systems. Our instrumentation solutions are built to monitor critical parameters such as speed, alignment, tension, and operational status in real-time. By utilizing advanced sensors and control units, we enable automated responses to potential faults, significantly reducing the risk of catastrophic failures and minimizing operational downtime."
  },
  comms: {
    title: "Communication Systems & Fiber Optics",
    detail: "Seamless communication is the backbone of modern industrial safety and efficiency. Profibercom offers comprehensive communication solutions, including leaky feeder networks, VHF/UHF radio repeaters, and high-bandwidth fiber optic installations. Our systems are engineered to perform reliably even during peak spectrum congestion and in harsh, electromagnetically noisy environments."
  },
  safety: {
    title: "Safety Interlocking & Monitoring",
    detail: "We supply, install, and maintain top-tier safety interlocking and monitoring equipment. This includes heavy-duty Scanbelt Safeline IV-R emergency pull-switches utilized along extended conveyor belts. Features include highly visible TRIP and RESET indicators, and advanced slackrope/tightrope detection capabilities to ensure rapid emergency shutdowns and personnel safety. Our systems are designed with fail-safes, non-contact operations, and intelligent false-trip elimination logic."
  }
};

const Services = () => {
  const [modalData, setModalData] = useState(null);

  return (
    <section id="services">
      <div className="section-hero">
        <div className="prlx-bg" style={{ backgroundImage: `url('/assets/images/movilitas-cloud-marketplace-promo-640x480.jpeg')` }}></div>
        <div className="prlx-overlay"></div>
        <div className="prlx-overlay-gold"></div>
        <div className="sh-content">
          <div className="sh-label">What We Do</div>
          <h2 className="sh-title">Our Core <em>Services</em></h2>
        </div>
      </div>

      <div className="sec services-sec">
        <div className="sec-inner">
          <div className="centered reveal">
            <div className="sec-label">Core Business & Services</div>
            <h2 className="sec-title">What We <em>Deliver</em></h2>
            <div className="divider"></div>
            <p className="sec-desc">Comprehensive engineering solutions designed for demanding industrial environments where safety and uptime are non-negotiable.</p>
          </div>
          
          <div className="svc-grid stagger-children" style={{ marginTop: '50px' }}>
            
            <div className="svc-card reveal">
              <div className="svc-img">
                <img src="/assets/images/headEndControlUnit.png" alt="Control" />
                <div className="svc-img-grad"></div>
              </div>
              <div className="svc-body">
                <span className="svc-chip">Service 01</span>
                <h3>Control & Instrumentation</h3>
                <p>Design, supply, and integration of industrial control systems monitoring critical parameters in real-time with automated fault response.</p>
                <button className="learn-more-btn" onClick={() => setModalData(modalContent.control)}>Learn More →</button>
              </div>
            </div>

            <div className="svc-card reveal">
              <div className="svc-img">
                <img src="/assets/images/HighSpeedFiberOpticCabling.png" alt="Fiber Optic" />
                <div className="svc-img-grad"></div>
              </div>
              <div className="svc-body">
                <span className="svc-chip">Service 02</span>
                <h3>Communication Systems & Fiber Optics</h3>
                <p>Comprehensive solutions including leaky feeder networks and high-bandwidth fiber optic installations — engineered to perform reliably.</p>
                <button className="learn-more-btn" onClick={() => setModalData(modalContent.comms)}>Learn More →</button>
              </div>
            </div>

            <div className="svc-card reveal">
              <div className="svc-img">
                <img src="/assets/images/dd64f983-29bb-43b5-9ea1-93a5c07d3c43-Smart-Monitor-for-Asset-eXcellence-is1357436548-500x500.jpeg" alt="Safety" />
                <div className="svc-img-grad"></div>
              </div>
              <div className="svc-body">
                <span className="svc-chip">Service 03</span>
                <h3>Safety Interlocking & Monitoring</h3>
                <p>Supply and installation of top-tier safety interlocking equipment — pull-switch monitoring, and intelligent emergency shutdown systems.</p>
                <button className="learn-more-btn" onClick={() => setModalData(modalContent.safety)}>Learn More →</button>
              </div>
            </div>

          </div>
        </div>

        {/* Modal Overlay */}
        {modalData && (
          <div className="modal-overlay" onClick={() => setModalData(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setModalData(null)}>✕</button>
              <div className="sec-label">Technical Specification</div>
              <h2 className="sec-title" style={{ fontSize: '28px', marginBottom: '20px' }}>{modalData.title}</h2>
              <div className="divider" style={{ margin: '0 0 20px 0' }}></div>
              <p style={{ lineHeight: '1.8', color: 'var(--muted)' }}>{modalData.detail}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;